/**
 * @generated SignedSource<<f5f05cf1e2f1613f77efa7266f23dbe9>>
 * @relayHash 26b5197a6da7434358942abf75a90ae9
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/547.0.0-2026-02-17T12:56:19.611Z/UserNotificationsTabsQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserNotificationsTabsQuery$variables = {
  hasTradeUserId: boolean;
  priceBookName: string;
  userCountryCode: string;
  userId: string;
};
export type UserNotificationsTabsQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"UserNotificationsTabs_viewer">;
  };
};
export type UserNotificationsTabsQuery = {
  response: UserNotificationsTabsQuery$data;
  variables: UserNotificationsTabsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasTradeUserId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestMessage",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestMessageReceivedAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "thumb"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"thumb\")"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Item",
  "kind": "LinkedField",
  "name": "item",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "buyerMember",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasUnreadTag",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasUnviewedTag",
      "storageKey": null
    },
    (v12/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v17 = [
  (v7/*: any*/),
  (v12/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotificationsTag",
  "kind": "LinkedField",
  "name": "unreadTag",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotificationsTag",
  "kind": "LinkedField",
  "name": "unviewedTag",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v12/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Item",
  "kind": "LinkedField",
  "name": "item",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    },
    (v12/*: any*/)
  ],
  "storageKey": null
},
v21 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
],
v22 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": (v21/*: any*/),
    "storageKey": null
  }
],
v23 = [
  (v12/*: any*/)
],
v24 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Anchor",
  "kind": "LinkedField",
  "name": "anchors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "source",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "token",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Transaction",
              "kind": "LinkedField",
              "name": "transaction",
              "plural": false,
              "selections": [
                (v13/*: any*/),
                (v12/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "OrderFeedback",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LoyaltyProgram",
              "kind": "LinkedField",
              "name": "programInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                (v12/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "ParentProgram",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "rewardEarned",
              "plural": false,
              "selections": (v21/*: any*/),
              "storageKey": null
            }
          ],
          "type": "TradeFirmReward",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TransactionSummaryObject",
              "kind": "LinkedField",
              "name": "summary",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "offerDiscountPercentage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v10/*: any*/),
                (v11/*: any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "buyerId",
                      "variableName": "userId"
                    },
                    {
                      "kind": "Variable",
                      "name": "isTrade",
                      "variableName": "hasTradeUserId"
                    },
                    {
                      "kind": "Variable",
                      "name": "priceBookName",
                      "variableName": "priceBookName"
                    },
                    {
                      "kind": "Variable",
                      "name": "userCountryCode",
                      "variableName": "userCountryCode"
                    }
                  ],
                  "concreteType": "ItemDisplayPriceType",
                  "kind": "LinkedField",
                  "name": "displayPrice",
                  "plural": true,
                  "selections": (v22/*: any*/),
                  "storageKey": null
                },
                (v12/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Offer",
              "kind": "LinkedField",
              "name": "mostRecentOffer",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "amountPerItem",
                  "plural": false,
                  "selections": (v22/*: any*/),
                  "storageKey": null
                },
                (v12/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Conversation",
              "kind": "LinkedField",
              "name": "conversation",
              "plural": false,
              "selections": (v17/*: any*/),
              "storageKey": null
            }
          ],
          "type": "Transaction",
          "abstractKey": null
        },
        (v24/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v23/*: any*/),
          "type": "Category",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotificationsTag",
  "kind": "LinkedField",
  "name": "unviewedTag",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v27 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserNotification",
    "kind": "LinkedField",
    "name": "all",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "payload",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "type": "Conversation",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/)
            ],
            "type": "FavoriteNotification",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v25/*: any*/)
            ],
            "type": "ActivityFeedElement",
            "abstractKey": null
          },
          (v24/*: any*/)
        ],
        "storageKey": null
      },
      (v6/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Conversation",
    "kind": "LinkedField",
    "name": "messages",
    "plural": true,
    "selections": [
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v12/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "FavoriteNotification",
    "kind": "LinkedField",
    "name": "favorites",
    "plural": true,
    "selections": [
      (v7/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v18/*: any*/),
      (v26/*: any*/),
      (v20/*: any*/),
      (v12/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ActivityFeedElement",
    "kind": "LinkedField",
    "name": "other",
    "plural": true,
    "selections": [
      (v7/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v18/*: any*/),
      (v26/*: any*/),
      (v25/*: any*/),
      (v12/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserNotification",
    "kind": "LinkedField",
    "name": "offers",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "payload",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v18/*: any*/),
              (v26/*: any*/),
              (v25/*: any*/)
            ],
            "type": "ActivityFeedElement",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v18/*: any*/),
              (v26/*: any*/),
              (v20/*: any*/)
            ],
            "type": "FavoriteNotification",
            "abstractKey": null
          },
          (v24/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserNotificationsTabsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserNotificationsTabs_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserNotificationsTabsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "UserNotifications",
            "kind": "LinkedField",
            "name": "userNotifications",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNotificationsBucket",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": (v27/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNotificationsBucket",
                "kind": "LinkedField",
                "name": "earlier",
                "plural": false,
                "selections": (v27/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Promotion",
                "kind": "LinkedField",
                "name": "activePromotion",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buyerDisplayable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PromotionMeta",
                    "kind": "LinkedField",
                    "name": "promotionMeta",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayMessage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayCta",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "adjustmentRateList",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reference",
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlatAdjustmentRate",
                    "kind": "LinkedField",
                    "name": "flatAdjustmentRate",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "kind": "LinkedField",
                        "name": "rate",
                        "plural": false,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PercentAdjustmentRate",
                    "kind": "LinkedField",
                    "name": "percentAdjustmentRate",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rate",
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/547.0.0-2026-02-17T12:56:19.611Z/UserNotificationsTabsQuery",
    "metadata": {},
    "name": "UserNotificationsTabsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "074888e8196c20350de402ad3cb6a7c5";

export default node;
